import { render, staticRenderFns } from "./TableCache.vue?vue&type=template&id=5ac55fe3&"
import script from "./TableCache.vue?vue&type=script&lang=js&"
export * from "./TableCache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports